import * as yup from "yup";

export const precinctSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required("Precinct name is required")
    .max(150, "Precinct name must be at most 150 characters"),
  location: yup
    .string()
    .trim()
    .required("Location is required")
    .max(255, "Location must be at most 255 characters"),
  total_assigned_voters: yup
    .number()
    .typeError("Total assigned voters must be a number")
    .transform((value, originalValue) =>
      originalValue === "" || originalValue === undefined ? null : value
    )
    .notRequired()
    .min(0, "Total assigned voters cannot be negative")
    .nullable(),
});

export async function validatePrecinct(data) {
  try {
    const validated = await precinctSchema.validate(data, { abortEarly: false });
    return { valid: true, values: validated, errors: {} };
  } catch (err) {
    const errors = {};
    if (err.inner && Array.isArray(err.inner)) {
      err.inner.forEach((e) => {
        if (e.path && !errors[e.path]) {
          errors[e.path] = e.message;
        }
      });
    } else if (err.path) {
      errors[err.path] = err.message;
    }
    return { valid: false, values: null, errors };
  }
}
